import React, {useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import GUIButton from "../GUIButton";
import recordIcon from "images/mainland/selfie-record.png";
import recordingIcon from "images/mainland/selfie-recording.png";
import "./index.scss";

const SelfieShootButton = ({onClick}) => {
  const isVideo = useSelector(state => state.selfie.type) === "VIDEO";
  const isRecording =
    useSelector(state => state.selfie.action.command) === "TAKE_SELFIE";
  const TIME_LIMIT = 60;
  const RADIUS = 54;
  const CIRCUMFERENCE = 3.3 * Math.PI * RADIUS;
  const [timeLimit, setTimeLimit] = useState(TIME_LIMIT);
  const barRef = useRef();
  const minute = Math.floor(timeLimit / 60);
  const seconds = timeLimit % 60;
  let timer;

  function progress(per) {
    const progress = per / 100;
    const dashoffset = CIRCUMFERENCE * (1 - progress);

    if (barRef.current) barRef.current.style.strokeDashoffset = dashoffset;
  }

  useEffect(() => {
    if (isVideo && isRecording) {
      timer = setInterval(() => {
        setTimeLimit(timeLimit => timeLimit - 1);
        if (timeLimit === 0) {
          onClick();
          clearInterval(timer);
        }
      }, 1000);

      progress(timeLimit);
    }
    return () => clearInterval(timer);
  }, [isRecording, timeLimit]);

  return (
    <>
      <GUIButton onClickFunc={onClick}>
        <div className="shoot-icon-wrapper">
          <svg
            className="circle_progress"
            width="120"
            height="120"
            viewBox="0 0 120 120"
          >
            <circle className="frame" cx="60" cy="60" r="54" strokeWidth="12" />
            <circle
              ref={barRef}
              className="bar"
              cx="60"
              cy="60"
              r="54"
              strokeWidth="12"
              strokeDasharray={CIRCUMFERENCE}
            />
          </svg>
          <div className="shoot-icon-container">
            {isVideo &&
              (isRecording ? (
                <>
                  <img
                    className="shoot-icon-img-recording"
                    src={recordingIcon}
                  />
                  <div className="record-timer">
                    <div className="record-timer-icon"></div>
                    <p className="record-timer-text">{`${minute}:${
                      seconds < 10 ? 0 : ""
                    }${seconds}`}</p>
                  </div>
                </>
              ) : (
                <img className="shoot-icon-img-record" src={recordIcon} />
              ))}
          </div>
        </div>
      </GUIButton>
    </>
  );
};

export default SelfieShootButton;
